import Layout from '@/components/Layout'

const storeRoutes = [
  {
    path: '/storeManagement',
    name: 'storeManagement',
    redirect: '/storeManagement/store',
    component: Layout,
    meta: {
        title: "门店管理",
        icon: "el-icon-s-shop",
        show: true
    },
    children: [
      {
        path: '/storeManagement/store',
        name: 'storeMgt',
        component: () => import(/* webpackChunkName: "about" */ '../../views/storeManagement/index.vue'),
        meta: {
          title: '门店管理',
          icon: "sidebar-dashboard",
          show: true
        },
      }
    ]
  }
]

export default storeRoutes
